// API URL configuration
// Uses REACT_APP_BACKEND_URL from environment if set
// Falls back to same-origin (empty string) for production deployments behind reverse proxy

const backendUrl = process.env.REACT_APP_BACKEND_URL || '';

// Use the env var directly - Emergent auto-updates it for both preview and production
export const API_URL = backendUrl;

// Helper to resolve image URLs through the backend
// Uploaded images are stored at /uploads/books/... and served by FastAPI at /api/uploads/books/...
export const getImageUrl = (url) => {
  if (!url) return null;
  if (url.startsWith('http://') || url.startsWith('https://')) return url;
  if (url.startsWith('/uploads/')) return `${API_URL}/api${url}`;
  return url;
};

console.log('API Configuration:', { 
  hostname: window.location.hostname, 
  API_URL 
});
